import { isImage, isVideo, isDocument } from 'utilities/file';

class SynchronizedPageRegions {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/synchronized-page-regions`;

  }

  async createSynchronizedPageRegion(synchronizedPageRegion) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, synchronizedPageRegion);

  }

  async getSynchronizedPageRegionById(synchronizedPageRegionId, projection) {

    const path = `${this.basePath}/:synchronizedPageRegionId`;

    return this.apiClient.get(path, { synchronizedPageRegionId }, { projection });

  }

  async updateSynchronizedPageRegionById(synchronizedPageRegionId, sourceId, nodes, updateKey) {

    const path = `${this.basePath}/:synchronizedPageRegionId`;

    return this.apiClient.put(path, { synchronizedPageRegionId }, {}, { sourceId, nodes, updateKey });

  }

  async incrementSynchronizedPageRegionReferencedCountById(synchronizedPageRegionId) {

    const path = `${this.basePath}/:synchronizedPageRegionId/referenced-count`;

    return this.apiClient.post(path, { synchronizedPageRegionId }, {}, {});

  }

  async decrementSynchronizedPageRegionReferencedCountById(synchronizedPageRegionId) {

    const path = `${this.basePath}/:synchronizedPageRegionId/referenced-count`;

    return this.apiClient.delete(path, { synchronizedPageRegionId }, {}, {});

  }

  async trackSynchronizedPageRegionReference(synchronizedPageRegionId, pageId) {

    const path = `${this.basePath}/:synchronizedPageRegionId/referenced-pages`;

    return this.apiClient.post(path, { synchronizedPageRegionId }, {}, { pageId });

  }

  async uploadFile(synchronizedPageRegionId, file) {

    let path = `${this.basePath}/:synchronizedPageRegionId`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    } else {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, { synchronizedPageRegionId }, {}, data, true);

  }

}

export default SynchronizedPageRegions;